import { createStore, applyMiddleware, compose, combineReducers, Store } from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';
import { apiClient } from './api.client';
import { reducers } from './reducers';
import { persistReducer } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import sagas from './global/sagas';
import { advisorApi } from './advisor/advisorApi';

export * from './auth.service';
export * from './payload-types';
export * from './utils';
export * from './mq';
export * from './na';
export * from './adfs';
export * from './cfm';
export * from './idle';
export * from './tms';
export * from './policy-search';
export * from './policy-info';
export * from './policy-delivery';
export * from './policy-history';
export * from './policy-notes';
export * from './traveller-selection';
export * from './travellers-details';
export * from './travellers-plan';
export * from './traveller-payments';
export * from './policy-create';
export * from './remerchandise';
export * from './policy-getpdf';
export * from './quote';
export * from './recommendation';
export * from './user-info';
export * from './user-listing';
export * from './user-profile';
export * from './config';
export * from './quote-form';
export * from './global';
export * from './destination';
export * from './organization';
export * from './policy-update';
export * from './policy-cancel';
export { reducers } from './reducers';
export * from './payload-types';
export * from './api.client';
export * from './request.mappers';
export * from './license';
export * from './report';
export * from './agency';
export * from './reprice';
export * from './advisor';
export * from './advisor/advisorApi';
export * from './download-rates';
export * from './allocations';
export * from './destination-multiplier';
export * from './advisorReports';

interface StoreGlobal {
  createStore?: (init: unknown, persistConfig) => Store;
}
declare global {
  interface Window {
    ReduxStore: StoreGlobal;
  }
}

const DEVELOPMENT = 'development';

export default (function (root, factory) {
  const ReduxStore: StoreGlobal = {};
  if (!root.ReduxStore) {
    root.ReduxStore = ReduxStore;
    factory(ReduxStore);
  }
  return root.ReduxStore;
})((typeof window === 'object' && window) || ({} as Record<string, StoreGlobal>), function (reduxStore) {
  let store;
  reduxStore.createStore = function (initialState = {}, persistConfig) {
    if (!store) {
      const thunkMiddleware = thunk.withExtraArgument(apiClient);
      const sagaMiddleware = createSagaMiddleware();

      // RTK Query middleware for caching, invalidation, and polling
      const rtkQueryMiddleware = advisorApi.middleware;

      const middleware =
        process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test'
          ? [thunkMiddleware, sagaMiddleware, rtkQueryMiddleware]
          : [thunkMiddleware, sagaMiddleware, rtkQueryMiddleware, logger];

      const composeEnhancers =
        process.env.NODE_ENV === DEVELOPMENT && typeof window !== 'undefined'
          ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
          : compose;

      store = createStore(
        persistReducer(persistConfig, combineReducers(reducers)),
        initialState,
        composeEnhancers(applyMiddleware(...middleware))
      );
      sagaMiddleware.run(sagas);
      return store;
    }
    return store;
  };
});
